import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 9l6 0","key":"svg-0"}],["path",{"d":"M4 5l4 0","key":"svg-1"}],["path",{"d":"M6 5v11a1 1 0 0 0 1 1h5","key":"svg-2"}],["path",{"d":"M12 8a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1l0 -2","key":"svg-3"}],["path",{"d":"M12 16a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1l0 -2","key":"svg-4"}]]

const IconSubtask = createReactComponent('outline', 'subtask', 'Subtask', __iconNode);

export default IconSubtask;